import dynamic from 'next/dynamic';

import CustomIcon from '@components/utils/CustomIcon';
import { FlexibleDiv } from '@components/formStyles';
import { LocationIcon } from '@assets/icons';
import Typography from '@components/Typography';
import { useDevice } from '@contexts/device';

import {
  Wrapper,
  LabelWrapper,
  SummaryWrapper,
  SummaryText,
  LocationName,
  MapWrapper,
} from './styled';

const Map = dynamic(() => import('@components/ui/map/Map'));

interface HotelLocationProps {
  locationName?: string;
  locationAddress?: string;
  latitude: number;
  longitude: number;
}

const HotelLocation = ({
  locationName,
  locationAddress,
  latitude,
  longitude,
}: HotelLocationProps) => {
  const { isDesktop } = useDevice();

  return (
    <Wrapper>
      <LabelWrapper>
        <Typography variant={isDesktop ? 'Title4' : 'Title2'} weight='Bold'>
          Otel Konumu
        </Typography>
      </LabelWrapper>

      <SummaryWrapper>
        <FlexibleDiv right={20}>
          <CustomIcon icon={LocationIcon} fontSize={43} paletteColor='coral' />
        </FlexibleDiv>

        <SummaryText>
          <LocationName>
            <Typography variant='caption1' weight='SemiBold'>
              {locationName}
            </Typography>
          </LocationName>
          <Typography variant='caption1'>{locationAddress}</Typography>
        </SummaryText>
      </SummaryWrapper>

      <MapWrapper fullScreen={false}>
        {locationName ? (
          <Map latitude={latitude} longitude={longitude} />
        ) : null}
      </MapWrapper>
    </Wrapper>
  );
};

export default HotelLocation;
